module.exports = __webpack_public_path__ + "img/strength-3.b9698865.png";